import { Icon } from "@vds/icons";
import { Modal, ModalBody, ModalFooter, ModalTitle } from "@vds/modals";
import { Body, Title } from "@vds/typography";

export const DeleteRolesModal = (props) => {
  const {
    message,
    title,
    onConfirm,
    onExit,
    setShowDeleteRole,
    showDeleteRole,
  } = props;
  return (
    <>
      <Modal
        opened={showDeleteRole}
        disableOutsideClick={true}
        ariaLabel={`${title} Modal`}
        surface="light"
        fullScreenDialog={false}
        hideCloseButton={true}
        disableAnimation={false}
        onClose={setShowDeleteRole}
        width={"800px"}
        closeButton={
          <div
            style={{
              cursor: "pointer",
              position: "absolute",
              right: "25px",
              top: "25px",
            }}
            onClick={onExit}
          >
            <Icon name="close" />
          </div>
        }
      >
        <ModalTitle>
          <Title size="large"><span style={{fontWeight:700,fontSize:32}}>{title}</span></Title>
        </ModalTitle>
        <ModalBody>
          <Body size="large">
            {message || "Are you sure you want to delete the Rule"}
          </Body>
        </ModalBody>
        <ModalFooter
          buttonData={{
            close: {
              width: "100%",
              children: "Yes, delete",
              onClick: onConfirm,
            },
            primary: {
              children: "No, cancel",
              width: "100%",
              onClick: onExit,
            }
          }}
        />
      </Modal>
    </>
  );
};